import { useEffect, useState } from 'react';
import { SpinningLoader } from '@frontend/design-system';
import { ContentNotFetchedPlaceholder } from './assets';
import { iframeStyles, imgContentPlaceholderStyles } from './review-link-styles';

type ReviewLinkIframeProps = {
  src: string;
};

export const ReviewLinkIframe = ({ src }: ReviewLinkIframeProps) => {
  const [isFrameLoading, setIsFrameLoading] = useState<boolean>(true);
  const [isFrameLoadError, setIsFrameLoadError] = useState<boolean>(false);

  /*
   * since iframe doesn't support onLoadStart to set loading true, it is being done on frame src change
   * loading will be reset to false on successful frameLoad or on frameLoadError
   * reset both frameLoadError and loading to false for when rendering other components instead of an iframe
   */
  useEffect(() => {
    if (!!src) {
      setIsFrameLoading(true);
    }
  }, [src]);

  const handleFrameOnLoad = () => {
    setIsFrameLoading(false);
  };

  const handleFrameLoadError = () => {
    setIsFrameLoading(false);
    setIsFrameLoadError(true);
  };

  return (
    <>
      {isFrameLoading ? (
        <SpinningLoader size='medium' />
      ) : isFrameLoadError ? (
        <img css={imgContentPlaceholderStyles} src={ContentNotFetchedPlaceholder} alt='No content' />
      ) : null}

      <iframe
        src={src}
        title='review-request-link-preview'
        style={iframeStyles(!(isFrameLoading || isFrameLoadError))}
        onLoad={handleFrameOnLoad}
        onError={handleFrameLoadError}
        sandbox='allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox'
      />
    </>
  );
};
